class CopyText extends  HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClick);
  }

  onClick() {
    if (!navigator.clipboard) {
      return;
    }

    navigator.clipboard.writeText(this.hasAttribute('data-text') ? this.getAttribute('data-text') : '').then(() => {
      
    });
  }
}
customElements.define('copy-text', CopyText);